module.exports = __webpack_public_path__ + "static/media/karta-mm.8ca1cea4.png";